export default {
  ACCEPT_LANGUAGE_HEADER: 'accept-language',
  APPLICATION_LOCALE: 'applicationLocale',
  HEADERS: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  },
  STATUS_WITH_NO_BODY: [204, 401, 404, 500, 501, 502, 503]
};